import { useEffect, useRef } from "react";
import { ReactComponent as Tiger1 } from "../assets/tiger-1.svg";
import { ReactComponent as Tiger2 } from "../assets/tiger-2.svg";
import { ReactComponent as Tiger3 } from "../assets/tiger-3.svg";

const ARTS = { 1: Tiger1, 2: Tiger2, 3: Tiger3 };

const TigerDraw = ({ n = 1, className = "", startDelay = 0.25 }) => {
  const ref = useRef(null);
  const Art = ARTS[n];

  useEffect(() => {
    const svg = ref.current;
    if (!svg) return;
    const paths = Array.from(svg.querySelectorAll("path"));
    const fillDelay = startDelay + paths.length * 0.006 + 0.5;
    paths.forEach((p, i) => {
      const fill = p.getAttribute("fill") || "#EE2126";
      p.setAttribute("pathLength", "1");
      p.style.stroke = fill;
      p.style.strokeWidth = "2";
      p.style.fillOpacity = "0";
      p.style.strokeDasharray = "1";
      p.style.strokeDashoffset = "1";
      p.style.transition = `stroke-dashoffset 0.9s cubic-bezier(0.4, 0, 0.2, 1) ${startDelay + i * 0.006}s, fill-opacity 0.7s ease ${fillDelay}s`;
    });
    const raf = requestAnimationFrame(() =>
      requestAnimationFrame(() => {
        paths.forEach((p) => {
          p.style.strokeDashoffset = "0";
          p.style.fillOpacity = "1";
        });
      })
    );
    return () => cancelAnimationFrame(raf);
  }, [startDelay]);

  return <Art ref={ref} className={className} data-testid={`tiger-draw-${n}`} />;
};

export default TigerDraw;
